module.exports = __webpack_public_path__ + "img/abbonamento-prepagata.af986a45.jpg";